import { Fragment } from 'react'
import {
  MoreVertical,
  Edit,
  Trash2,
  Link2,
  CheckSquare,
  Printer,
  Paperclip,
  FolderOpen,
  Copy,
  Scale
} from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'

interface InteractionActionsMenuProps {
  interactionId?: string
  onEdit?: () => void
  onDelete?: () => void
  onLink?: () => void
  onTransformToCase?: () => void
  onTransformToProcess?: () => void
  onPrint?: () => void
  onAttachDocument?: () => void
  onCreateTask?: () => void
  onDuplicate?: () => void
}

export function InteractionActionsMenu({
  interactionId: _interactionId,
  onEdit,
  onDelete,
  onLink,
  onTransformToCase,
  onTransformToProcess,
  onPrint,
  onAttachDocument,
  onCreateTask,
  onDuplicate
}: InteractionActionsMenuProps) {
  const actions = [
    {
      label: 'Editar',
      icon: Edit,
      onClick: onEdit
    },
    {
      label: 'Vincular a caso/processo',
      icon: Link2,
      onClick: onLink
    },
    {
      label: 'Transformar em caso',
      icon: FolderOpen,
      onClick: onTransformToCase
    },
    {
      label: 'Transformar em processo',
      icon: Scale,
      onClick: onTransformToProcess
    },
    {
      label: 'Criar tarefa',
      icon: CheckSquare,
      onClick: onCreateTask
    },
    {
      label: 'Anexar documento',
      icon: Paperclip,
      onClick: onAttachDocument
    },
    {
      label: 'Duplicar',
      icon: Copy,
      onClick: onDuplicate
    },
    {
      label: 'Imprimir',
      icon: Printer,
      onClick: onPrint
    },
    {
      label: 'Excluir',
      icon: Trash2,
      onClick: onDelete,
      separator: true,
      destructive: true
    }
  ]

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label="Mais ações"
          className="shrink-0 text-muted-foreground"
          onClick={(e) => e.stopPropagation()}
        >
          <MoreVertical className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        {actions.map((action) => {
          const IconComponent = action.icon
          return (
            <Fragment key={action.label}>
              {action.separator && <DropdownMenuSeparator />}
              <DropdownMenuItem
                variant={action.destructive ? 'destructive' : 'default'}
                onSelect={() => action.onClick?.()}
              >
                <IconComponent className="size-4" />
                <span>{action.label}</span>
              </DropdownMenuItem>
            </Fragment>
          )
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
